import type { Offer, OfferType } from '@makemydeal/dr-platform-types';
import type { PartialPenciledInputsWithAllTypes, PenciledInputsState } from '../../../types/commonTypes';
import * as types from '../../../types/actionTypes';
import { applyPenciledInputsProgram } from '../helpers';
import { cleanSavedRatesWhenEnabled } from '../../../utils/savedTermRateUtils';

export const handleSyncAndResetCases = (
    state: PenciledInputsState,
    action: any,
    offerType: OfferType,
    offer?: Offer
): PartialPenciledInputsWithAllTypes => {
    switch (action.type) {
        case types.SYNC_MESSAGE: {
            return cleanSavedRatesWhenEnabled({ ...state, ...action.message.offer.penciledInputs }, offer?.featureToggles);
        }

        case types.RESET_OFFER: {
            return {
                ...state,
                byOfferType: applyPenciledInputsProgram(state, action, offerType, { selectedIncentives: [] })
            };
        }

        default: {
            return state;
        }
    }
};
